import React, { useState } from 'react';

import Carousel, { SwiperSlide } from '@components/Carousel/Carousel';
import { HotelEventsViewModel } from '@api/index';
import { useBreakpoint } from '@contexts/breakpoints';

import EventInfoModal from './EventInfoModal';
import HotelEventCard from './HotelEventCard';
import EventKrokiModal from './EventKrokiModal';

const HotelEvents = ({ data }: { data: HotelEventsViewModel[] }) => {
  const { xl } = useBreakpoint();
  const [selected, setSelected] = useState<
    (HotelEventsViewModel & { dates?: string[] }) | null
  >(null);
  const [open, setOpen] = useState(false);
  const [visibleKrokiModal, toggleVisibleKrokiModal] = useState(false);

  const handleShowDetails = (event: HotelEventsViewModel) => {
    setSelected(event);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelected(null);
  };

  return (
    <div>
      <Carousel
        navigation
        loop={Boolean(data?.length > 2)}
        slidesPerView={xl ? 2 : 1}
        spaceBetween={16}
        breakpoints={undefined}
      >
        {data?.map((item) => (
          <SwiperSlide key={item.id} style={{ width: '100%' }}>
            <HotelEventCard
              data={item}
              onShowDetails={handleShowDetails}
              toggleKrokiModal={() => {
                setSelected(item);
                toggleVisibleKrokiModal(true);
              }}
            />
          </SwiperSlide>
        ))}
      </Carousel>
      {visibleKrokiModal ? (
        <EventKrokiModal
          image={
            selected?.eventImageGallery?.find(
              (item) => item.hotelEventImageType === 'SeatingArrangement'
            )?.imageUrl
          }
          title='Oturma Düzeni'
          description={selected?.seatingArrangementInformation}
          toggleKrokiModal={() => toggleVisibleKrokiModal(false)}
        />
      ) : null}
      {open ? (
        <EventInfoModal
          isVisible={true}
          onClose={handleClose}
          title={selected?.title}
          image={selected?.image}
          dates={selected?.dates}
          artistName={selected?.artistName}
          description={selected?.description || selected?.shortDescription}
        />
      ) : null}
    </div>
  );
};
export default HotelEvents;
